import React, { forwardRef, useState } from 'react';
import {
  Button,
  Dialog,
  Slide,
  IconButton,
  Grid,
  DialogContent,
  makeStyles,
  Paper,
  SvgIcon,
  Container,
  Typography
} from '@material-ui/core';
import { Close, Share, Link, CheckCircleOutline } from '@material-ui/icons';
import { mainRoute } from '../../routes/routes.json';
import DialogInformation from './DialogInformation';
import RecallTabs from './RecallTabs';
import { shareData } from '../../utils/common';
import playStoreImg from '../../assets/static/Play-Store.png';
import appStoreImg from '../../assets/static/App-Store.png';

import { appStoreLink, playStoreLink, playStoreReviewLink } from '../../routes/routes.json';
import openInNewTab from '../../utils/common';

const useStyle = makeStyles((theme) => ({
  dialogContent: {
    padding: 0,
    paddingTop: '0 !important',
    margin: '0 auto',
    overflowX: 'hidden',
    maxWidth: 960,
  },
  cardImg: {
    width: '100%',
    height: 340,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover', //'100% 100%' //Stretched
    backgroundColor: '#ffffff',
    [theme.breakpoints.only('sm')]: {
      height: 380,
    },
    [theme.breakpoints.only('md')]: {
      height: 450,
    },
  },
  content: {
    position: 'relative',
    bottom: 40,
    width: '100%',
    borderRadius: '0 0 0 0',
    boxShadow: '0 -6px 6px rgba(0,0,0,0.16)',
    paddingTop: 35,
    [theme.breakpoints.only('sm')]: {
      paddingTop: 30,
    },
  },
  dialogActionsContainer: {
    [theme.breakpoints.only('sm')]: {
      paddingLeft: 5,
      paddingRight: 5,
    },
    [theme.breakpoints.only('md')]: {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  dialogDesktop: {
    borderRadius: 0,
  },
  dialogDesktopClose: {
    paddingTop: 0,
  },
  // dialogDesktopShare: {
  //   paddingTop: 5,
  //   position: 'absolute',
  //   left: 32,
  // },
  dialogDesktopImg: {
    width: 200,
  },
  dialogImg: {
    height: 400,
    borderRadius: 30,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  mainInformation: {
    paddingLeft: 30,
  },
  tabsContainer: {
    [theme.breakpoints.only('xs')]: {
      marginTop: 25,
    },
    marginTop: 20,
  },
  titleStubContainer: {
    // display:  (window.isMobileApp) ? "none" : "block",
    display: "block"
  },
  titleStub: {
    paddingTop: 15,
    color: 'white',
    fontSize: 26,
    textShadow: "1px 1px 2px black",
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.secondary.main,
  },
  copyrightStub: {
    paddingTop: 15,
    color: 'grey',
    fontSize: 14,
    margin: '0 auto'
  },
  mobileAppContainer: {
    display: window.isMobileApp ? "none" : "flex",
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 20
  },
  rateAppContainer: {
    display: window.isMobileApp ? "flex" : "none",
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 20
  },
  appStoreBanner: {
    height: 40,
    cursor: "pointer",
    paddingLeft: 10,
    paddingRight: 10,
  },
  installCTA: {
    fontSize: 24,
    fontColor: "black",
    textAlign: "center",
    paddingBottom: 20,
  },
  reviewCTA: {
    fontSize: 18,
    fontColor: "black",
    textAlign: "center",
    textDecoration: "underline",
    paddingBottom: 20,
  },
  customButton: {
    color: "grey", // Replace with a specific grey shade if needed, e.g., '#757575'
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogRecall = (props) => {
  const { open, handleClose, handleImgClicked, recall } = props;
  const classes = useStyle();

  const [tabValue, setTabValue] = useState(0);

  const currentYear = new Date().getFullYear(); // Dynamically fetch the current year

  const handleTabChange = (event, newTabValue) => {
    setTabValue(newTabValue);
  };

  const handleChangeIndex = (index) => {
    //console.log("Setting tab bar index to", index)
    if (index === 2) {
      if (!recall.hasMap()) {
        setTabValue(0);
        return;
      }
    }
    setTabValue(index);
  };

  const handleShareRecall = (e) => {
    e.preventDefault();

    let link = `${mainRoute}/${recall.compositeId}`;

    console.log(link);

    shareData({
      title: 'Share',
      text: "Here's the food recall:",
      url: link,
      fallbackAlertMessage: 'Link copied to clipboard.'
    })
  };

  const handleAppStoreClick = (e) => {
    e.preventDefault();
  
    openInNewTab(appStoreLink);
  };
  
  const handlePlayStoreClick = (e) => {
    e.preventDefault();
  
    openInNewTab(playStoreLink);
  };

  const handlePlayStoreReviewClick = (e) => {
    e.preventDefault();
  
    openInNewTab(playStoreReviewLink);
  };

  return (
    <>
      { recall !== null ? (
        <Dialog
          fullScreen
          // contentStyle={{ margin: 0, padding: 0 }}
          scroll={'body'}
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >

          <DialogContent className={classes.dialogContent}>
          <Grid container //Image banner
            style={{
              backgroundImage: `url(${recall.getBannerURL()})`,
            }}
            className={classes.cardImg}
          >
            <Grid container className={classes.dialogActionsContainer}>
              <Grid item xs={1}>
                <Grid container justify="flex-start">
                  <IconButton
                    edge="start"
                    color="secondary"
                    size="medium"
                    onClick={handleClose}
                  >
                    <SvgIcon
                      component={Close}
                      fontSize="large"
                      stroke="black"
                      strokeWidth={1}
                      strokeLinecap="round"
                    />
                  </IconButton>
                </Grid>
              </Grid>
              <Grid item xs={10}>
                <Grid container justify="flex-start" className={classes.titleStubContainer}>
                    <Typography
                      variant="h2"
                      color="secondary"
                      className={classes.titleStub}
                    >
                      {recall.getAlertType()}
                    </Typography>
                </Grid>
              </Grid>
              <Grid item xs={1}>
                <Grid container justify="flex-end">
                  <a
                    href="/#"
                    onClick={handleShareRecall}
                    className={classes.link}
                  >
                    <IconButton edge="end" color="secondary" size="medium">
                      <SvgIcon
                        component={Share}
                        fontSize="large"
                        stroke="black"
                        strokeWidth={1}
                        strokeLinecap="round"
                      />
                    </IconButton>
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Paper elevation={0} className={classes.content}>
            <Container>
              <DialogInformation recall={recall} />
              <Grid container>
                <Grid item xs={12} className={classes.tabsContainer}>
                  <RecallTabs
                    recall={recall}
                    tabValue={tabValue}
                    handleTabChange={handleTabChange}
                    handleChangeIndex={handleChangeIndex}
                    handleImgClicked={handleImgClicked}
                  />
                </Grid>
              </Grid>
            </Container>
            <Grid container>
            <Grid item xs={6}>
              <Grid container justify="flex-start">
              <a
                  href={recall.getLearnMoreURL()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                >
                  { recall.isClosed()?
                  (<Button
                      variant="text"
                      size="large"
                      startIcon={<CheckCircleOutline />}
                      className={classes.customButton}
                    >
                      {recall.getStatus()}
                    </Button>)
                    : null }
                </a>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container justify="flex-end">
                <a
                  href={recall.getLearnMoreURL()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.link}
                >
                  {
                    !(recall.shouldHideCTAButton()) ?
                      (<Button
                          variant="text"
                          size="large"
                          startIcon={<Link />}
                          className={classes.customButton}
                        >
                          {recall.getCTAButtonTitle()}
                        </Button>)
                        : null
                  }
                </a>
              </Grid>
            </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container className={classes.mobileAppContainer}>
                <Grid item xs={12}>
                  <Typography variant="h3" className={classes.installCTA}>
                    Download App to Stay Safe
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Grid container justify="flex-end">
                    <img src={appStoreImg} alt="AppStore" className={classes.appStoreBanner} onClick={handleAppStoreClick} />
                  </Grid>
                </Grid>
                <Grid item xs={6}>
                  <Grid container justify="flex-start">
                  <img src={playStoreImg} alt="PlayStore" className={classes.appStoreBanner} onClick={handlePlayStoreClick} />
                  </Grid>
                </Grid>
              </Grid>

              <Grid container className={classes.rateAppContainer}>
                <Grid item xs={12}>
                  <Typography variant="h3" className={classes.reviewCTA} onClick={handlePlayStoreReviewClick}>
                    Please leave a review to help others
                  </Typography>
                </Grid>
              </Grid>

              <Grid container>
                    <Typography
                      variant="h4"
                      color="secondary"
                      className={classes.copyrightStub}
                    >
                      &copy; {currentYear} SmartAddress, Inc.
                    </Typography>
              </Grid>
            </Grid>
          </Paper>
          </DialogContent>
        </Dialog>
      ) :
      null }
    </>
  );
};

export default DialogRecall;
